<template>
  <div class="form-group">
    <n-input ref="input" v-bind="$attrs" v-model="fileName" @input.native="onFileInput" type="file" class="form-group--file-uploader mb-0">
      <template slot="append">
        <transition name="scale-transition" mode="out-in">
        <n-progress-circular v-if="progress < 100" v-model="progress" class="mx-3" size="20" :width="3" />
        <n-icon v-else gm class="success--text mx-3">check_circle</n-icon>
      </transition>
      </template>
      <slot name="label" slot="label" slot-scope="{label}" :label="label"></slot> <!-- forward label slot content to <n-input>'s label slot -->
      <slot name="prepend" slot="prepend"></slot> <!-- forward prepend slot content to <n-input>'s prepend slot -->
      <slot name="append" slot="append"></slot> <!-- forward prepend slot content to <n-input>'s prepend slot -->
      <slot name="help" slot="help"></slot> <!-- forward help slot content to <n-input>'s help slot -->
      <slot name="default" slot="default"></slot> <!-- forward default slot content to <n-input>'s default slot -->
    </n-input>
    
    <slot name="selected-file" v-if="isFileSelected && previewFile" :file="file" :file-size="fileSize">
      <section class="mt-4">        
        <small class="grey--text">Preview</small>
        <n-tile>
          <n-tile-content v-if="isFileImage" class="pa-0"> 
            <n-image :src="imagePreviewSrc" center style="width: 100%; height: auto; max-width: 100%; max-height: 30em;"/>
          </n-tile-content>    
          <n-tile-content class="grey lighten-4">
           <slot name="preview"><div style="min-width: 10em;">
              Type: {{file.type}}<br>
              Size: {{fileSize | number}} bytes
           </div></slot>
          </n-tile-content>
        </n-tile>
      </section>
    </slot>

  </div>
</template>

<script>
  export default {

    props: {
      value: { required: true },
      progress: { type: Number, default: 0 },
      previewFile: { type: Boolean, default: true },
    },

    data () {
      return {
        file: null,
        fileName: null,
      }
    },


    computed: {

      isFileSelected() {
        return this.file != null
      },

      fileSize() {
        return this.file.size
      },

      isFileImage() {
        return /image/i.test(this.file.type)
      },
      
      imagePreviewSrc() {
        return URL.createObjectURL(this.file)
      },

    },

    watch: {
      file() {
        this.$emit('input', this.file) 
      },

      value: {
        handler() { this.file = this.value },
        immediate: true,
      }
    },

    methods: {
      onFileInput() {
        this.file = this.$refs.input.$refs.controlEl.files[0] 
      },
    },
  }
</script>